import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "../api";
import { useAuth } from "../AuthContext";
import { Page, SectionTitle } from "../components/Layout";
import {
  DashboardTab, CoworkingTab, TricoTab, FlashTab, VetrinaTab,
  ReferralTab, PaymentsTab, CorsiTab, SettingsTab, AuditTab, GestionaleTab, ResidentiTab,
} from "./AdminSections";
import AcademyTab from "./AdminAcademy";

const SECTIONS = [
  ["dashboard", "Dashboard"], ["coworking", "Coworking"], ["residenti", "Resident"], ["trico", "Tricopigmentazione"],
  ["flash", "Flash Day"], ["vetrina", "Vetrina"], ["referral", "Inviti / Premi"],
  ["corsi", "Corsi / Eventi"], ["academy", "MAS Academy"], ["pagamenti", "Pagamenti"], ["gestionale", "Gestionale"], ["impostazioni", "Impostazioni"],
  ["log", "Sicurezza / Log"],
];

export default function AdminPage() {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [tab, setTab] = useState("dashboard");
  const [period, setPeriod] = useState({ preset: "30d", start: "", end: "" });
  const [dash, setDash] = useState(null);
  const [courseEnr, setCourseEnr] = useState([]);
  const [txFilter, setTxFilter] = useState("all");
  const [vFilter, setVFilter] = useState("all");
  const [data, setData] = useState({
    artists: [], bookings: [], packages: [], expiring: [], trico: [], flashDays: [],
    vetrina: [], vouchers: [], transactions: [], settings: null, courses: [], audit: [],
  });

  useEffect(() => { if (!loading && (!user || user.role !== "admin")) nav("/"); }, [user, loading]); // eslint-disable-line

  const loadDash = (p = period) => {
    const q = p.preset === "custom" && p.start && p.end
      ? `preset=custom&start=${p.start}&end=${p.end}` : `preset=${p.preset}`;
    api.get(`/admin/dashboard?${q}`).then((r) => setDash(r.data)).catch(() => {});
  };
  const g = (u, k, f = (x) => x) => api.get(u).then((r) => setData((d) => ({ ...d, [k]: f(r.data) }))).catch(() => {});
  const loadLists = () => {
    g("/admin/artists", "artists");
    g("/admin/bookings", "bookings");
    g("/admin/packages", "packages");
    g("/admin/packages-expiring", "expiring");
    g("/admin/leads-crm", "trico", (r) => r.filter((l) => (l.source || "").toUpperCase() === "TRICOPIGMENTAZIONE"));
    g("/admin/flash-days", "flashDays");
    g("/admin/vetrina", "vetrina");
    g("/admin/settings", "settings");
    g("/admin/courses", "courses");
    g("/admin/audit-log", "audit");
    g(`/admin/referral-vouchers?filter=${vFilter}`, "vouchers");
    g(`/admin/transactions?filter=${txFilter}`, "transactions");
  };
  useEffect(() => { if (user?.role === "admin") { loadDash(); loadLists(); } }, [user]); // eslint-disable-line
  useEffect(() => { if (user?.role === "admin") loadDash(); }, [period]); // eslint-disable-line
  useEffect(() => { if (user?.role === "admin") g(`/admin/transactions?filter=${txFilter}`, "transactions"); }, [txFilter]); // eslint-disable-line
  useEffect(() => { if (user?.role === "admin") g(`/admin/referral-vouchers?filter=${vFilter}`, "vouchers"); }, [vFilter]); // eslint-disable-line

  const act = async (fn, msg = "Fatto") => {
    try {
      const r = await fn();
      if (r?.data?.refund_status === "failed") toast.error("Il messaggio è stato rifiutato, ma il rimborso non è riuscito. Verifica lo stato prima di riprovare.");
      else toast.success(typeof msg === "function" ? msg(r) : msg);
      loadDash(); loadLists();
      return true;
    }
    catch (e) { toast.error(apiErr(e)); return false; }
  };
  const loadCourseEnrollments = (cid) => { setCourseEnr([]); api.get(`/admin/courses/${cid}/enrollments`).then((r) => setCourseEnr(r.data)).catch(() => {}); };

  if (loading || !user || user.role !== "admin") return <Page><div className="text-center text-gray-400 pt-20">…</div></Page>;

  const label = SECTIONS.find(([k]) => k === tab)?.[1];
  return (
    <Page>
      <SectionTitle sub="Centro operativo MAS — gestione quotidiana da smartphone.">Area Admin</SectionTitle>
      <div className="mb-5">
        <select data-testid="admin-section-select" value={tab} onChange={(e) => setTab(e.target.value)}
          className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm font-medium bg-white focus:border-violet-500 outline-none">
          {SECTIONS.map(([k, l]) => <option key={k} value={k}>{l}</option>)}
        </select>
      </div>
      <div className="mb-4"><h3 className={`serif text-xl ${tab === "corsi" ? "text-center" : ""}`}>{label}</h3></div>

      {tab === "dashboard" && <DashboardTab dash={dash} period={period} setPeriod={setPeriod} goto={setTab} />}
      {tab === "coworking" && <CoworkingTab data={data} act={act} />}
      {tab === "residenti" && <ResidentiTab />}
      {tab === "trico" && <TricoTab data={data} act={act} />}
      {tab === "flash" && <FlashTab data={data} act={act} />}
      {tab === "vetrina" && <VetrinaTab data={data} act={act} settings={data.settings} />}
      {tab === "referral" && <ReferralTab data={data} act={act} filter={vFilter} setFilter={setVFilter} />}
      {tab === "corsi" && <CorsiTab data={data} act={act} courses={data.courses} enrollments={courseEnr} loadCourseEnrollments={loadCourseEnrollments} />}
      {tab === "academy" && <AcademyTab />}
      {tab === "pagamenti" && <PaymentsTab data={data} act={act} filter={txFilter} setFilter={setTxFilter} />}
      {tab === "gestionale" && <GestionaleTab period={period} />}
      {tab === "impostazioni" && <SettingsTab data={data} act={act} />}
      {tab === "log" && <AuditTab data={data} />}
    </Page>
  );
}
